const Spinner = ({ className = "" }) => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className={`animate-spin rounded-full h-8 w-8 border-b-2 border-primary ${className}`} />
    </div>
  );
};

export default Spinner; 